import React, { Component } from "react";
import { Alert, Button, Spin } from "antd";
import ReCAPTCHA from "react-google-recaptcha";

import { GetData } from "../../api/service";
import { RECAPTCHA_SITE_KEY } from "../../Helper/GlobalConstants";

/**
 * Step 2 — pick which admission receipt to reprint.
 *
 * 42% of students hold more than one admission receipt, so the choice is real.
 * A single receipt is pre-selected; several are listed unselected so nobody
 * pays for the wrong one by accident.
 */
export default class AdmissionPrintForm extends Component {
  state = {
    types: [],
    admission_print_type_id: "",
    admission_receipt_id: "",
    // a fresh token: reCAPTCHA tokens are single-use, so step 1's is spent
    recaptcha_token: "",
    message: "",
    isLoadingTypes: true
  };

  componentDidMount() {
    GetData("/getadmissionprinttype").then((resp) => {
      let types = Array.isArray(resp) ? resp : [];
      this.setState({
        types,
        // there is only ever one reprint type in practice
        admission_print_type_id: types.length > 0 ? types[0].id : "",
        isLoadingTypes: false
      });
    });

    if (this.props.receipts.length === 1) {
      this.setState({ admission_receipt_id: this.props.receipts[0].id });
    }
  }

  selectedType = () => {
    return this.state.types.filter(
      (el) => String(el.id) === String(this.state.admission_print_type_id)
    )[0];
  };

  onSubmit = () => {
    if (this.state.admission_receipt_id === "") {
      this.setState({ message: "Please choose which receipt you want reprinted" });
      return;
    }

    if (this.state.admission_print_type_id === "") {
      this.setState({ message: "Reprint fee is not configured. Please contact the college office." });
      return;
    }

    if (this.state.recaptcha_token === "") {
      this.setState({ message: "Please complete the captcha" });
      return;
    }

    this.setState({ message: "" });

    this.props.onSubmit({
      roll_no: this.props.student.roll_no,
      email: this.props.student.email,
      admission_print_type_id: this.state.admission_print_type_id,
      admission_receipt_id: this.state.admission_receipt_id,
      recaptcha_token: this.state.recaptcha_token
    });
  };

  render() {
    let type = this.selectedType();
    let receipts = this.props.receipts;

    return (
      <div>
        <h5>Your admission fee receipts</h5>
        <p style={{ marginBottom: 14 }}>
          {receipts.length === 1
            ? "This is the receipt on record against your roll number."
            : `You have ${receipts.length} admission fee receipts. Choose the one you want reprinted.`}
        </p>

        {receipts.map((r, i) => (
          <div className="radio" key={i}>
            <label>
              <input
                type="radio"
                name="admission_receipt_id"
                checked={String(this.state.admission_receipt_id) === String(r.id)}
                onChange={() => this.setState({ admission_receipt_id: r.id })}
              />
              &nbsp;
              <b>Receipt No. {r.receipt_no}</b>
              &nbsp;&mdash;&nbsp; {r.date}
              &nbsp;&mdash;&nbsp; &#8377; {r.amount_paid}
              <div style={{ marginLeft: 20, fontSize: 12, color: "#666" }}>
                {r.particulars}
                {r.term ? ` · Term ${r.term}` : ""}
                {r.mop ? ` · ${r.mop}` : ""}
              </div>
            </label>
          </div>
        ))}

        <br />

        {this.state.isLoadingTypes ? (
          <Spin />
        ) : type ? (
          <Alert
            type="info"
            showIcon
            message={`${type.type_name} — ₹ ${type.registration_fee}`}
            description="Pay this fee, then collect the reprinted receipt from the college office."
          />
        ) : (
          <Alert
            type="error"
            showIcon
            message="Reprint requests are not open yet. Please contact the college office."
          />
        )}

        <br />

        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={(token) => this.setState({ recaptcha_token: token || "" })}
        />
        <br />

        {this.state.message !== "" && (
          <div>
            <Alert type="error" showIcon message={this.state.message} />
            <br />
          </div>
        )}

        {this.props.isSubmitting ? (
          <Spin />
        ) : (
          <Button type="primary" disabled={!type} onClick={this.onSubmit}>
            Submit and proceed to payment
          </Button>
        )}
      </div>
    );
  }
}
